import {Config} from "../../__snowpack__/link/packages/config/dist/config.esm.js";
import React, {useMemo} from "react";
import styled, {createGlobalStyle} from "styled-components";
import {FormFieldsetContainer} from "../components/atoms/form/form.styles.js";
export const MainContainer = styled.main.withConfig({
  displayName: "generic-reactstyles__MainContainer",
  componentId: "sc-s9az1b-0"
})(["", ""], {
  display: "flex",
  flexDirection: "column",
  width: "100%"
});
export const FormTitleRowContainer = styled.div.withConfig({
  displayName: "generic-reactstyles__FormTitleRowContainer",
  componentId: "sc-s9az1b-1"
})(["", ""], {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "flex-start",
  width: "100%",
  marginLeft: "-0.25rem",
  marginTop: "1.5rem",
  marginBottom: "0.5rem"
});
export const FormRowContainer = styled.div.withConfig({
  displayName: "generic-reactstyles__FormRowContainer",
  componentId: "sc-s9az1b-2"
})(["", " > *:not(:last-child){", "}"], {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "flex-start",
  width: "100%",
  marginLeft: "1rem"
}, {
  marginRight: "1rem"
});
export const FormContainer = styled.section.withConfig({
  displayName: "generic-reactstyles__FormContainer",
  componentId: "sc-s9az1b-3"
})(["", " ", "+", "{", "}", "{", "}"], {
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  alignItems: "center"
}, FormRowContainer, FormRowContainer, {
  marginTop: "1rem"
}, FormFieldsetContainer, {
  paddingLeft: "3.5rem",
  paddingRight: "3.5rem",
  paddingTop: "1.5rem",
  paddingBottom: "1.5rem"
});
export const DEFAULT_THEME = {
  primaryColor: "#36475F",
  secondaryColor: "#2895F1",
  tertiaryColor: "#A9B1BC",
  successColor: "#7ED321",
  warningColor: "#F5A623",
  errorColor: "#CE3B4D",
  auxColor: "#861B89"
};
export const DEFAULT_SKINNING = {
  aux_color: "#861B89",
  error_color: "#CE3B4D",
  primary_color: "#36475F",
  success_color: "#7ED321",
  warning_color: "#F5A623",
  tertiary_color: "#A9B1BC",
  secondary_color: "#2895F1",
  web_url: window.location.origin,
  api_url: Config.dmEnvironment.host,
  media_url: Config.dmEnvironment.mediaHost,
  default_email: "",
  company_help_email: "",
  principal_logo: null,
  public_logo: null,
  favicon_logo: null,
  mobile_in_app_logo: null,
  mobile_app_skin_logo: null
};
function ThemeStylesComponent({
  theme
} = {}) {
  const chosenColors = useMemo(() => ({
    ...DEFAULT_THEME,
    ...theme
  }), [theme]);
  const GlobalStyle = createGlobalStyle(["body{--primaryColor:", ";--secondaryColor:", ";--tertiaryColor:", ";--successColor:", ";--warningColor:", ";--errorColor:", ";--auxColor:", ";", "}"], chosenColors.primaryColor, chosenColors.secondaryColor, chosenColors.tertiaryColor, chosenColors.successColor, chosenColors.warningColor, chosenColors.errorColor, chosenColors.auxColor, {
    "--tw-text-opacity": "1",
    color: "rgba(42, 57, 78, var(--tw-text-opacity))",
    transitionProperty: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "200ms"
  });
  return /* @__PURE__ */ React.createElement(GlobalStyle, null);
}
export const ThemeStyles = /* @__PURE__ */ React.memo(ThemeStylesComponent);
